export function getContentChangelogUrl(_ref) {
  var contentId = _ref.contentId,
    _ref$withAdminBasePat = _ref.withAdminBasePath,
    withAdminBasePath = _ref$withAdminBasePat === void 0 ? true : _ref$withAdminBasePat;
  var path = "/logs/contents?search=".concat(encodeURIComponent("id:".concat(contentId)));
  if (withAdminBasePath) {
    return "/admin".concat(path);
  } else {
    // In the admin dashboard, the base path `/admin` isn't needed
    return path;
  }
}